export const SEGMENT_BRAND = 'NerdWallet Wealth Partners'
export const SEGMENT_DEPLOYABLE_NAME = 'nerdwallet-wealth-partners'

export function segmentAdsTimestamps() {
  const now = Date.now()
  return {
    ads_timestamp: new Date(now).toISOString(),
    ads_timestamp_unix: Math.floor(now / 1000),
  }
}
